import { render, staticRenderFns } from "./AppFormTextEditorItn.vue?vue&type=template&id=901996fe&scoped=true&"
import script from "./AppFormTextEditorItn.vue?vue&type=script&lang=js&"
export * from "./AppFormTextEditorItn.vue?vue&type=script&lang=js&"
import style0 from "./AppFormTextEditorItn.vue?vue&type=style&index=0&id=901996fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901996fe",
  null
  
)

export default component.exports